import * as React from 'react';
import { observer } from 'mobx-react-lite';
import EmptySearchResponse from './EmptySearchResponse';
import Loading from './Loading';
import NoResults from './NoResults';
import Results from './Results';
import PivotAndFilter from './PivotAndFilter';

import * as styles from './styles.scss';

export default observer(function TimestreamSearchResults() {
    return (
        <div className={styles.searchResultsContainer}>
            <PivotAndFilter />
            <Loading />
            <div className={styles.searchResults}>
                <EmptySearchResponse />
                <NoResults />
                <Results />
            </div>
        </div>
    );
});
